var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st3{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000136377885022211659660000007953937877372823180_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.7466,
    y1: 1025.1538,
    x2: 969.351,
    y2: 47.53,
    gradientTransform: "matrix(1 0 0 -1 0 1000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#253B80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#179BD7"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.01,50h495.98C859.56,50,950,140.44,950,252.01v495.98C950,859.56,859.56,950,747.99,950H252.01 C140.44,950,50,859.56,50,747.99V252.01C50,140.44,140.44,50,252.01,50z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    className: "st2",
    d: "M669.74,377.33l-1.56,9.04c-20.57,105.06-90.41,141.22-179.88,141.22H442.8 c-10.88,0.02-20.14,7.95-21.82,18.7l-23.38,147.77l-6.55,41.77c-1.03,6.29,3.22,12.22,9.51,13.25c0.67,0.11,1.35,0.16,2.02,0.15 h80.74c9.57,0.13,17.79-6.77,19.33-16.21v-4.05l14.96-96.33v-5.3c1.4-9.57,9.66-16.62,19.33-16.52h12.16 c78.25,0,139.35-31.17,155.87-124.7c9.74-31.98,3.72-66.69-16.21-93.52C683.27,386.53,676.85,381.38,669.74,377.33z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    className: "st3",
    d: "M648.23,368.91l-9.66-2.49l-10.29-1.87c-13.21-1.99-26.55-2.93-39.9-2.81H466.8 c-9.55,0.05-17.63,7.07-19.02,16.52l-25.87,163.66v4.68c1.69-10.75,10.94-18.68,21.82-18.7h45.51 c89.47,0,159.3-36.16,179.88-141.22c0-3.12,0-6.23,1.56-9.04c-5.4-2.86-11.03-5.26-16.83-7.17L648.23,368.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    className: "st0",
    d: "M447.47,377.95c1.39-9.45,9.47-16.47,19.02-16.52h121.58c13.46-0.14,26.91,0.8,40.21,2.81 l10.29,1.87l9.66,2.49h4.68c5.8,1.92,11.43,4.32,16.83,7.17c8-31.35,0.21-64.63-20.89-89.16 c-23.07-26.19-64.84-37.72-118.15-37.72H374.84c-10.88,0.02-20.14,7.95-21.82,18.7l-64.22,411.19 c-1.03,7.33,4.07,14.11,11.4,15.15c0.56,0.08,1.13,0.12,1.69,0.13h95.7l24-152.44L447.47,377.95z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.5edfbdeac4d5efd788b8d436b42981cd.svg";
export { ForwardRef as ReactComponent };